import {Auth, LoginForm} from '..'

export default function Login() {
  return (
    <Auth func="login">
      <LoginForm />
    </Auth>
  )
}
